module.exports = __webpack_public_path__ + "frown.9e0eda0e.png";